<div class="modal-header">
  <h3 class="modal-title">Comparativo NDVI</h3>
</div>

<div class="modal-body">
  <div google-chart chart="$comparativo.chart" class="width-100" style="height: 600px;">
  </div>
</div>
